import { AuthenticationService } from "@auth/authentication.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app.component";
import { AppRoutes } from "./app.routing";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppHttpInterceptor } from "./app.interceptor";
import { BlockUIModule } from "primeng/blockui";
import { AppService } from "./app.service";
import { TokenService } from "./authorization/token.service";
import { AuthorizationModule } from "./authorization/authorization.module";
import { PdfViewerModule } from "@shared/pdf-viewer/pdf-viewer.module";
import { PdfService } from "@shared/pdf-viewer/pdf.service";
import { HomeComponent } from "./home/home.component";
import { VerificateComponent } from "./verificate/verificate.component";
import { FormsModule } from "@angular/forms";
import { PipeModule } from "@shared/pipes/pipe.module";
import { NgxMaskModule } from "ngx-mask";
import { AdminLayoutModule } from "@shared/admin-layout/admin-layout.module";
import { environment } from "@env/environment";
import { ConfigService } from "./config.service";

export function ConfigLoader(configService: ConfigService): () => Promise<any> {
  return () => configService.load(environment.configFile);
}

@NgModule({
  declarations: [AppComponent, HomeComponent, VerificateComponent],
  imports: [
    BrowserAnimationsModule,
    AdminLayoutModule,
    HttpClientModule,
    BlockUIModule,
    AuthorizationModule,
    PdfViewerModule,
    FormsModule,
    PipeModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(),
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
      relativeLinkResolution: "legacy",
    }),
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [ConfigService],
      multi: true,
    },
    AppService,
    TokenService,
    AuthenticationService,
    PdfService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
